import './LiksSwitch.css';

export type LiksSwitchProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** Accessible name for the switch control. */
  'aria-label': string;
  id?: string;
  disabled?: boolean;
  className?: string;
};

export function LiksSwitch({
  checked,
  onChange,
  'aria-label': ariaLabel,
  id,
  disabled = false,
  className,
}: LiksSwitchProps) {
  return (
    <button
      id={id}
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      className={['liks-switch', checked && 'liks-switch--on', className]
        .filter(Boolean)
        .join(' ')}
      onClick={() => onChange(!checked)}
    >
      <span className="liks-switch__track" aria-hidden>
        <span className="liks-switch__thumb" />
      </span>
    </button>
  );
}
